import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'CpeMatch' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        padding: 8,
        borderRadius: 8,
        border: '1px solid #ECECEC',
        background: '#FFF'
    },
    criteria: {
        width: 16,
        height: 16,
        color: '#D7D7D6'
    }
});
